<template>
  <div class="wrapper" style="padding:20px;">
    <el-tabs v-model="activeName">
      <el-tab-pane label="价格体系" name="first">
        <valuationDetalis />
      </el-tab-pane>
  </el-tabs>
  </div>
</template>

<script>
import valuationDetalis from './components/valuationDetalis.vue'
  export default {
    components:{
      valuationDetalis,
    },
    data(){
      return {
          activeName:'first'
      }
    },
    created(){},
    methods:{},
  }
</script>
<style scoped lang='scss'>
</style>